import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { TrainListChangeType } from "../../../Orchestrator/Types/Index";
import { TrainType } from "../../../Orchestrator/Types/Types/TrainTypes";
import { filterTrains } from "../../../Lib/Utils/validationUtil";
import dayjs from "dayjs";

export class TrainListChangeAction extends BaseAction<TrainType[], TrainListChangeType> {

    //This method call only when round trip and with same date of outbound and inbound and filter trains before arrival of Outbound Train
    filterByArrivalTime(trains: TrainType[], arrivalTime: string): TrainType[] {
        const [arrivalHour, arrivalMinute] = arrivalTime.split(":").map(num => parseInt(num, 10));
        return trains.filter(train => {
            const [departureHour, departureMinute] = train.departureTime.split(":").map(num => parseInt(num, 10));
            if (departureHour < arrivalHour) return false;
            if (departureHour === arrivalHour && departureMinute <= arrivalMinute) return false;
            return true;
        });
    }

    // Filters outbound trains: keep only those whose arrival is strictly before the inbound's departure.
    filterByDepartureTime(trains: TrainType[], departureTime: string): TrainType[] {
        const [depHour, depMinute] = departureTime.split(":").map(num => parseInt(num, 10));
        return trains.filter(train => {
            const [arrHour, arrMinute] = train.arrivalTime.split(":").map(num => parseInt(num, 10));
            if (arrHour < depHour) return true;
            if (arrHour === depHour && arrMinute < depMinute) return true;
            return false;
        });
    }

    override async run(): Promise<TrainType[] | null> {
        const { trainData, filter, type, search, selectedOutboundTrain, selectedInboundTrain, isChangeDate, selectedRange, selectedDate, inboundSelectedDate, originalOutboundArrival, originalInboundDeparture, isBookReturnJourneyAtom } = this.params!;
        let filteredTrains = [...trainData];
        try {
            // Handle normal round trip booking
            if (!isChangeDate && type === TrainTypeEnum.inbound && search?.inboundDate?.isSame(search?.outboundDate, "day") && selectedOutboundTrain?.arrivalTime) {
                filteredTrains = this.filterByArrivalTime(filteredTrains, selectedOutboundTrain.arrivalTime);
            }

            // Handle change date trip flow — OUTBOUND list: filter by inbound's departure time on same-day round trips
            if (isChangeDate && type === TrainTypeEnum.outbound && selectedRange?.[0]) {
                let boundaryDeparture: string | undefined;
                let boundaryDate: dayjs.Dayjs | undefined;

                if (selectedInboundTrain?.departureTime && selectedRange[1]) {
                    boundaryDeparture = selectedInboundTrain.departureTime;
                    boundaryDate = dayjs(selectedRange[1]);
                } else if (!selectedRange[1] && inboundSelectedDate && originalInboundDeparture) {
                    boundaryDeparture = originalInboundDeparture;
                    boundaryDate = dayjs(inboundSelectedDate);
                }

                if (boundaryDeparture && boundaryDate
                    && dayjs(selectedRange[0]).isSame(boundaryDate, "day")) {
                    filteredTrains = this.filterByDepartureTime(filteredTrains, boundaryDeparture);
                }
            }

            //INBOUND TRAIN
            if (isChangeDate && type === TrainTypeEnum.inbound && selectedRange?.[1]) {
                let boundaryArrival: string | undefined;
                let boundaryDate: dayjs.Dayjs | undefined;

                if (selectedOutboundTrain?.arrivalTime && selectedRange[0]) {
                    boundaryArrival = selectedOutboundTrain.arrivalTime;
                    boundaryDate = dayjs(selectedRange[0]);
                } else if (!selectedRange[0] && selectedDate && originalOutboundArrival) {
                    boundaryArrival = originalOutboundArrival;
                    boundaryDate = dayjs(selectedDate);
                }

                if (boundaryArrival && boundaryDate
                    && dayjs(selectedRange[1]).isSame(boundaryDate, "day")) {
                    filteredTrains = this.filterByArrivalTime(filteredTrains, boundaryArrival);
                }
            }

            //IS BOOK RETURN INBOUND TRAIN
            if (isBookReturnJourneyAtom && type === TrainTypeEnum.inbound && selectedRange && selectedDate) {
                if (selectedRange[0] && selectedDate
                    && dayjs(selectedRange[0]).isSame(dayjs(selectedDate), "day")) {
                    filteredTrains = this.filterByArrivalTime(filteredTrains, dayjs(selectedDate).format("HH:mm"));
                }
            }

            const result = filterTrains(filteredTrains, filter, type);
            updateRecoilState("filterTrainsAtom", result)
        } catch (error) {
            console.error("Error in TrainListChangeAction:", error);
        } finally {
            const trainDataResult = filterTrains(trainData, filter, type)
            return trainDataResult;
        }
    }
}

// Create a singleton instance
export const trainListChangeAction = new TrainListChangeAction(); 